var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('div',{staticClass:"customer-usage"},[_c('report-usages-list',{attrs:{"customer-id":_vm.customer?.id,"show-no-energy":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }